import type {ValueEditorOptions} from '../../../kp-value-editor/types';
import type {Formatter, Parser} from '../../forms/types';
import type {TextValueEditorOptions} from '../text/types';
import {isNullOrUndefined} from 'shared/utils/custom-utils';
import {LocalizationAwareError} from '../../errors/localization-aware-error';

export function emptyAsNullParser(options: ValueEditorOptions): Parser {
    return (viewValue: string | any[]): string | any[] | null => {
        if (!options.emptyAsNull) {
            return viewValue;
        }
        if (isEmpty(viewValue, options)) {
            return null;
        }
        return viewValue;
    };
}

export function emptyAsNullFormatter(options: ValueEditorOptions, emptyValue: string | [] = ''): Formatter {
    return (modelValue: string | any[] | null): string | any[] => {
        if (!options.emptyAsNull) {
            return modelValue;
        }
        if (modelValue === null) {
            return emptyValue;
        }
        return modelValue;
    };
}

export function trim(options: TextValueEditorOptions): Parser {
    return (modelValue: string): string => {
        if (modelValue && options.trim) {
            return modelValue.trim();
        }
        return modelValue;
    };
}

function isEmpty(modelValue: string | any[], options: ValueEditorOptions): boolean {
    if (options.customEmptyAsNullCheck) {
        return options.customEmptyAsNullCheck({value: modelValue});
    }
    return isNullOrUndefined(modelValue) || modelValue.length === 0;
}

export function throwParseErrorIfNaN(value: number | null): number {
    if (Number.isNaN(value)) {
        throw new LocalizationAwareError('number', 'Parsed value is not number');
    }
    return value;
}